<template>
  <div class="pricing-table-row list_panel header">
    <slot/>
  </div>
</template>

<script>
export default {

}
</script>
